import React, { useState } from "react";

import CreatePopPlanStep1 from "./CreatePopPlanStep1";
import CreatePopPlanStep2 from "./CreatePopPlanStep2";
import CreatePopPlanStep3 from "./CreatePopPlanStep3";
import CreatePopPlanStep4 from "./CreatePopPlanStep4";

import CreatePopPlanStep5Plans from "./CreatePopPlanStep5Plans";
import CreatePopPlanStep6 from "./CreatePopPlanStep6";
import CreatePopPlanStep8 from "./CreatePopPlanStep8";
import CreatePopPlanStep9 from "./CreatePopPlanStep9";
import CreatePopPlanStep10 from "./CreatePopPlanStep10";

const CreatePopWizard = () => {
  const [activeStep, setActiveStep] = useState(0);

  const [formData, setFormData] = useState({
    planName: "",
    channelPartnerType: "all",
    selectedChannelPartners: [],
    scopeType: "project",
    projectId: "",
    projectName: "",  
    wingIds: [],
    unitIds: [],
    startDate: "",
    endDate: "",
    isActive: true,
    brokerageType: "percentage",
    percentage: "",
    fixedAmount: "",
    eligibilityRules: [],
    conflictStrategy: null,
    requiresCpSignOff: true,     // can replace with requireSignOff if you want
    requireSignOff: true,        // new field used in Step 8 component
    signOffStart: "",            // new
    signOffEnd: "",              // new
    calculationBasis: "count",
    rewardType: "fixed",
    rangeRules: [
      { from: "", to: "", amount: "" },
    ],
    eligibility: {
      siteVisitEnabled: false,
      siteVisitMin: "",
      siteVisitMax: "",
      fosEnabled: false,
      fosMin: "",
      fosMax: "",
    },
  });

  return (
    <>
      {/* Step 1 */}
      {activeStep === 0 && (
        <CreatePopPlanStep1
          data={formData}
          setData={setFormData}
          onNext={() => setActiveStep(1)}
        />
      )}

      {/* Step 2 (POP Validity) */}
      {activeStep === 1 && (
        <CreatePopPlanStep4
          data={formData}
          setData={setFormData}
          onBack={() => setActiveStep(0)} // Go back to Step 1
          onNext={() => setActiveStep(2)} // Proceed to Step 3
        />
      )}

      {/* Step 3 */}
      {activeStep === 2 && (
        <CreatePopPlanStep2
          data={formData}
          setData={setFormData}
          onBack={() => setActiveStep(1)} // Go back to Step 2
          onNext={() => setActiveStep(3)} // Proceed to Step 4
        />
      )}

      {/* Step 4 */}
      {activeStep === 3 && (
        <CreatePopPlanStep3
          data={formData}
          setData={setFormData}
          onBack={() => setActiveStep(2)} // Go back to Step 3
          onNext={() => setActiveStep(4)} // Proceed to Step 5
        />
      )}

      {/* Step 5 */}
      {activeStep === 4 && (
        <CreatePopPlanStep5Plans
          data={formData}
          setData={setFormData}
          onBack={() => setActiveStep(3)} // Go back to Step 4
          onNext={() => setActiveStep(5)} // Proceed to Step 6
        />
      )}

      {/* Step 6 */}
      {activeStep === 5 && (
        <CreatePopPlanStep6
          data={formData}
          setData={setFormData}
          onBack={() => setActiveStep(4)} // Go back to Step 5
          onNext={() => setActiveStep(6)} // Proceed to Step 7
        />
      )}

      {/* Step 7 */}
      {activeStep === 6 && (
        <CreatePopPlanStep8
          data={formData}
          setData={setFormData}
          onBack={() => setActiveStep(5)} // Go back to Step 6
          onNext={() => setActiveStep(7)} // Proceed to Step 8
        />
      )}

      {/* Step 8 */}
      {activeStep === 7 && (
        <CreatePopPlanStep9
          data={formData}
          setData={setFormData}
          onBack={() => setActiveStep(6)} // Go back to Step 7
          onNext={() => setActiveStep(8)} // Proceed to Step 9
        />
      )}

      {/* Step 9 */}
      {activeStep === 8 && (
        <CreatePopPlanStep10
          data={formData}
          setFormData={setFormData}
          onBack={() => setActiveStep(7)} // Go back to Step 8
          onNext={() => setActiveStep(1)} // Proceed to Step 2 after Step 9 (or back to the beginning)
        />
      )}
    </>
  );
};

export default CreatePopWizard;